module.exports = __webpack_public_path__ + "e95bf1ce1b76a1ad7e82779ae33b6999.MP3";